export const VIEW_WEEKLY = 'features/PeriodRange/VIEW_WEEKLY';
export const VIEW_MONTHLY = 'features/PeriodRange/VIEW_MONTHLY';
export const VIEW_YEARLY = 'features/PeriodRange/VIEW_YEARLY';
